import React from 'react';

const Close = props => {
    return (
        <svg width={9} height={9} viewBox="0 0 9 9" {...props}>
            <g fill="#8f99dc">
                <path
                    data-name="Path 2628"
                    d="M1 9a1 1 0 01-.707-1.707l7-7a1 1 0 011.414 1.414l-7 7A1 1 0 011 9z"
                />
                <path
                    data-name="Path 2629"
                    d="M8 9a1 1 0 01-.707-.293l-7-7A1 1 0 111.707.293l7 7A1 1 0 018 9z"
                />
            </g>
        </svg>
    );
};

export default Close;
